export const OfferControlsTexts = {
  sendOfferLabel: 'Узнать решение',
  sendMplOfferLabel: 'Выбрать',
};
